<template>
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 512.000000 512.000000"
         preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
           fill="#000000" stroke="none">

            <path d="M1005 5106 c-50 -22 -83 -69 -90 -128 -3 -29 -5 -289 -3 -578 l3
                    -525 1645 0 1645 0 0 572 c0 562 0 572 -21 599 -11 15 -33 37 -48 48 -27 21
                    -38 21 -486 21 -534 0 -482 12 -567 -126 -121 -198 -310 -309 -523 -309 -213
                    0 -402 111 -523 309 -85 137 -35 126 -555 128 -356 2 -453 0 -477 -11z"/>
            <path d="M912 1836 c3 -1734 3 -1735 24 -1762 11 -15 33 -37 48 -48 27 -21 38
                    -21 486 -21 534 0 482 -12 567 126 121 198 310 309 523 309 213 0 402 -111
                    523 -309 85 -138 33 -126 567 -126 448 0 459 0 486 21 15 11 37 33 48 48 21
                    27 21 28 24 1762 l2 1734 -1650 0 -1650 0 2 -1734z"/>

        </g>

        <text x="300" y="380" fill="red" font-size="200px"><slot></slot></text>

    </svg>
</template>

<script>
    export default {
        name: "si_ticket",
        props:{
            size:{
                type: String,
                default: '48px'
            },
            direction:{
                type: String,
                default: 'rtl'
            }
        }
    }
</script>

<style scoped lang="scss">


</style>